import React, { useRef, useState } from 'react';
import { useHotkeys } from 'react-hotkeys-hook';
import { useSnackbar } from 'material-ui-snackbar-provider';

import Modal from '../../modules/Modal';
import styles from './DeleteGroupModal.module.scss';
import { NOTIFICATION } from '../../../enums/ENUMS';
import { deleteGroupById } from '../../../api/groupsApi';
import { ContainedButton, OutlinedButton } from '../../modules/Buttons';

type TDeleteGroupModal = {
  id: string;
  open: boolean;
  switchModal: () => void;
  setFetchTrigger: (num: number) => void;
};

const DeleteGroupModal: React.FC<TDeleteGroupModal> = ({ id, open, switchModal, setFetchTrigger }) => {
  const notification = useSnackbar();
  const submitButtonRef = useRef<HTMLDivElement>(null);
  const [loading, setLoading] = useState(false);
  const handleDelete = async () => {
    setLoading(true);
    try {
      await deleteGroupById(id);
      switchModal();
      setFetchTrigger(Date.now());
    } catch (err) {
      // @ts-ignore
      if (err?.response?.data?.message) {
        // @ts-ignore
        notification.showMessage(err?.response?.data?.message);
      } else {
        notification.showMessage(NOTIFICATION.NOT_UPDATED);
      }
    } finally {
      setLoading(false);
    }
  };

  useHotkeys('Enter', () => {
    if (open && !loading) submitButtonRef?.current?.click();
  });

  return (
    <Modal open={open} onClose={switchModal} loading={loading}>
      <div className={styles.modalBody}>
        <div className={styles.modalTitle}>
          Are you sure you want to delete <br /> this group?
        </div>
        <div className={styles.form}>
          <div className={styles.actionBtns}>
            <OutlinedButton onClick={handleDelete} kind="default">
              <div ref={submitButtonRef}>Yes, I am sure</div>
            </OutlinedButton>

            <ContainedButton kind="purple" onClick={switchModal}>
              No, cancel
            </ContainedButton>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default DeleteGroupModal;
